import type { Session } from '@supabase/supabase-js';
import { createContext, useContext } from 'react';

import type { Profile } from './types';

export type SessionStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthContextValue {
  status: SessionStatus;
  session: Session | null;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const value = useContext(AuthContext);
  if (!value) throw new Error('useAuth debe usarse dentro de <AuthProvider>.');
  return value;
}

export interface CurrentUser {
  session: Session;
  profile: Profile;
}

export const CurrentUserContext = createContext<CurrentUser | null>(null);

/** Authenticated, active user. Only available below <RequireAuth>. */
export function useCurrentUser(): CurrentUser {
  const value = useContext(CurrentUserContext);
  if (!value) throw new Error('useCurrentUser debe usarse dentro de <RequireAuth>.');
  return value;
}
